import React from "react"
import { graphql, PageProps } from "gatsby"
import Template from "@app/components/Product/Product"

export type Props = PageProps<GatsbyTypes.TemplateProductQuery, GatsbyTypes.TemplateProductQueryVariables>

export const query = graphql`
  query TemplateProduct($handle: String!) {
    product: sanityProduct(shopify: { handle: { eq: $handle }, deleted: { ne: true }, published: { eq: true } }) {
      ...SanityProductFragment
      metadata {
        ...MetadataFragment
      }
      siblings: _rawSiblings(resolveReferences: { maxDepth: 1 })
      related: _rawRelated(resolveReferences: { maxDepth: 3 })
      fragrences: _rawFragrences(resolveReferences: { maxDepth: 6 })
      giftSet: _rawGiftSet(resolveReferences: { maxDepth: 3 })
      howToUse: _rawHowToUse(resolveReferences: { maxDepth: 6 })
      productHighlights: _rawProductHighlights(resolveReferences: { maxDepth: 6 })
      _type
    }
    template: sanityTemplateProduct {
      tolstoyTickerItems
      tolstoyTitle
      tolstoySubTitle
      tolstoyStories
      additionalProductRecommended
      additionalProductRecentlyViewed
      settingEnableReviews
      metadata {
        ...MetadataTemplateFragment
      }
    }
  }
  fragment SanityProductFragment on SanityProduct {
    id: _id
    url
    title
    descriptionHtml
    tags
    image
    shopify {
      id
      handle
      raw
    }
  }
`

const Component: React.FC<Props> = ({ data, ...props }) => <Template {...props} {...data} />
export default Component
